import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { queryClient } from './api/queryClient';
import { AppRouter } from './router';
import { ToastProvider } from './components/ToastProvider';
import { ViewportGate } from './components/ViewportGate';
import { AuthGuard } from './components/AuthGuard';
import { AppShell } from './components/AppShell';

// Side-effect import: instantiating apiClient attaches axios interceptors and
// must happen exactly once. Kept at module-top so it executes before any
// React render path that might fire a request.
import './api/client';

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <ViewportGate>
          <BrowserRouter>
            <AuthGuard>
              <AppShell>
                <AppRouter />
              </AppShell>
            </AuthGuard>
          </BrowserRouter>
        </ViewportGate>
      </ToastProvider>
    </QueryClientProvider>
  );
}
